import { useNavigate } from 'react-router-dom'
import { openChannelFromUrl } from '@/shared/lib/openChannelFromUrl'
import { useTVStore } from '@/shared/store'
import { useTopMenu } from '@/widgets/TopMenu/hooks/useTopMenu'
import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'
import { epgPagePath, tvPagePath, vodPagePath } from '@/shared/constants'
import useChannelChangeHook from '@/components/tv/hooks/useChannelChangeHook'

export const useExternalLinkHandlerToya = () => {
    const navigate = useNavigate()
    const { channelsData } = useTVStore()
    const { handleTvClick, handleEpgClick, handleVodClick } = useTopMenu()
    const { handleChannelChange } = useChannelChangeHook()
    const Analytics = useAnalytics()

    const handleExternalLink = (externalUri?: string) => {
        if (!externalUri) return

        const channelId = openChannelFromUrl(externalUri, 'livetv', 'contentId')
        const program = openChannelFromUrl(externalUri, 'program')
        const vod = openChannelFromUrl(externalUri, 'vod')
        const http = openChannelFromUrl(externalUri, 'http')
        if (channelId) {
            const channel = channelsData.find(
                (channel) => channel.id === channelId
            )
            if (channel) {
                handleTvClick()
                navigate(tvPagePath)
                handleChannelChange(channel)
            }
        } else if (program && !http) {
            navigate(epgPagePath)
            handleEpgClick()
        } else if (vod && !http) {
            navigate(vodPagePath)
            handleVodClick(true)
        } else {
            window.open(externalUri, 'external link')
        }

        Analytics?.analyticsLogEvent('deeplink_item_click', { to: externalUri })
    }

    return { handleExternalLink }
}
